import  Forgotpassword  from '../user/Forgotpassword';
import  Changepassword  from '../user/Changepassword';
import Login from '../user/Login';
import StripeSuccess from '../user/StripeSuccess';

export default {
    Login: {
        component: Login,
        path: '/'
    },
    Forgotpassword: {
        component: Forgotpassword,
        path: '/forgotpassword'
    },
    Changepassword: {
        component: Changepassword,
        path: '/changepassword/:code'
    },
    StripeSuccess: {
        component: StripeSuccess,
        path: '/StripeSuccess'
    }
};